import { useEffect, useState } from 'react';
import { getExtensionUnitById, updateExtensionUnit } from '../../services/extensionUnit/editExtensionUnitService.js';
import { isNameValid, isDescriptionValid } from '../../utils/validations/extensionUnitValidations.js';

const initialForm = {
    name: '',
    description: ''
};

export const useEditExtensionUnit = (id) => {
    const [form, setForm] = useState(initialForm);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [validationErrors, setValidationErrors] = useState([]);

    useEffect(() => {
        const loadExtensionUnit = async () => {
            try {
                const extensionUnit = await getExtensionUnitById(id);
                setForm({ ...initialForm, ...extensionUnit });
            } catch (err) {
                setError(
                    err.response?.status === 404
                        ? 'Unidad no encontrada.'
                        : 'Error al obtener los datos de la unidad.'
                );
            }
        };

        loadExtensionUnit();
    }, [id]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const submit = async () => {
        if (!isNameValid(form.name)){
            setError('El nombre de la unidad solo pueden contener letras.');
            return;
        }
        if (!isDescriptionValid(form.description)){
            setError('La descripción no puede contener caracteres especiales.');
            return;
        }
        // Si todo esta validado, procedimiento guardar
        try {
            await updateExtensionUnit(id, {
                ...form
            });
            setSuccess('La unidad ha sido actualizada exitosamente.');
            setValidationErrors([]);
        } catch (err) {
            // Validación del archivo: middleware/validator.js del backend
            if (err.response?.status === 400 && Array.isArray(err.response.data?.errors)) {
                setValidationErrors(err.response.data.errors);
                return;
            }
            // Error general
            setError(
                err.response?.data?.error || 
                err.response?.data?.message || 
                'Error al actualizar la unidad.'
            );
        }
    }

    const clearMessages = () => {
        setError('');
        setSuccess('');
        setValidationErrors([]);
    };

    return {
        form,
        error,
        success,
        validationErrors,
        handleChange,
        submit,
        clearMessages
    };
}